import moment from 'moment'
import _ from 'lodash'

export default invoiceSituation

/** @ngInject */
function invoiceSituation($uibModal) {
    return ({
        restrict: 'E',
        scope: {
            situation: '<',
            userInfo: '<',
            onSituationUpdated: '&',
        },
        template: require('./invoiceSituation.jade')(),
        link($scope) {
            const $controllerScope = $scope
            $scope.payStatus = { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING' }
            $scope.situationDetails = []
            $scope.situationSelected = {}
            $scope.sleek = undefined

            const getCurrentOrFirst = function (dateLabel, selectedPeriod, details) {
                const isSameMonth = (selectedPeriod) => (detail) => moment(selectedPeriod).isSame(detail[dateLabel], 'month')
                const getCurrentDetail = (selectedPeriod, details) => _.filter(details, isSameMonth(selectedPeriod))[0]
                return _.defaultTo(getCurrentDetail(selectedPeriod, details), _.first(details))
            }

            const updateSituation = function (situation) {
                $scope.sleek = situation.sleek
                $scope.situationDetails = situation.details
                $scope.situationSelected = getCurrentOrFirst('withdrawDate', moment(), situation.details)
            }

            $scope.selectSituation = (situation) => {
                $scope.situationSelected = situation
            }

            $scope.shouldDisplayRegulateBtn = () => {
                const BALANCE_THRESHOLD = -1
                return _.toNumber($scope.userInfo.contractSelected.contractBalance.balance) < BALANCE_THRESHOLD
            }

            $scope.openChangeSamplingDateModal = () => {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    template: require('../modal/modal-change-sampling-date.jade')(),
                    resolve: {
                        paymentDayInfo(BillingAcc, ErrorCatcher) {
                            return BillingAcc.getPaymentDay().$promise
                            .catch(ErrorCatcher.catchError)
                        },
                    },
                    controller($scope, $uibModalInstance, ErrorCatcher, BillingAcc, paymentDayInfo) {
                        $scope.form = paymentDayInfo
                        $scope.submit = () => {
                            BillingAcc.putPaymentDay({ preferredPaymentDay: $scope.form.preferredPaymentDay }).$promise
                            .catch(ErrorCatcher.catchError)
                            $uibModalInstance.dismiss()
                        }
                        $scope.close = () => {
                            $uibModalInstance.dismiss()
                        }
                    },
                })
            }

            $scope.openRegulateSituationPopup = (situationSelected) => {
                $uibModal.open({
                    animation: true,
                    template: require('../modal/modal-regulate-situation.jade')(),
                    resolve: {
                        situationSelected() {
                            return situationSelected
                        },
                    },
                    controller($scope, $uibModalInstance, ErrorCatcher, Invoice, situationSelected) {
                        const PAYMENT_STATUS_ABORDED_BY_CLIENT_ERROR = 90
                        const PAYMENT_STATUS_RTRANSAC_ERROR = 95
                        const generatePaymentStatus = [PAYMENT_STATUS_ABORDED_BY_CLIENT_ERROR, PAYMENT_STATUS_RTRANSAC_ERROR]
                        $scope.situationSelected = situationSelected
                        $scope.isSubmitted = false
                        $scope.errorMessage = null
                        $scope.regulateByCreditCard = () => {
                            $scope.errorMessage = null
                            return Invoice.getPayment({ payment_id: situationSelected.idPayment }).$promise
                            .then((result) => {
                                if (generatePaymentStatus.indexOf(result.status) > -1) {
                                    return Invoice.sendRegulateSituation({ id_payment: result.id }).$promise
                                }
                                return result
                            })
                            .then((result) => Invoice.creditCardRedirect({ id_payment: result.id }).$promise)
                            .then((result) => {
                                window.location = result.redirectUrl
                            })
                            .catch((error) => {
                                $scope.errorMessage = _.get(error, 'data.details.message', error.data.message)
                                return ErrorCatcher.catchError(error)
                            })
                        }
                        $scope.submit = () => {
                            Invoice.sendRegulateSituation({ id_payment: situationSelected.idPayment }).$promise
                            .then(() => {
                                $scope.isSubmitted = true
                                $controllerScope.onSituationUpdated()
                            })
                            .catch(ErrorCatcher.catchError)
                        }
                        $scope.close = () => {
                            $uibModalInstance.dismiss()
                        }
                    },
                })
            }

            $scope.openPayNextPaymentPopup = (situationSelected) => {
                $uibModal.open({
                    animation: true,
                    template: require('../modal/modal-pay-next-payment.jade')(),
                    controller($scope, $uibModalInstance, ErrorCatcher, Invoice) {
                        $scope.situationSelected = situationSelected
                        $scope.isSubmitted = false
                        $scope.submit = () => {
                            Invoice.sendPayNextPayment({ id_payment: situationSelected.idPayment }).$promise
                            .then(() => {
                                $scope.isSubmitted = true
                                $controllerScope.onSituationUpdated()
                            })
                            .catch(ErrorCatcher.catchError)
                        }
                        $scope.close = () => {
                            $uibModalInstance.dismiss()
                        }
                    },
                })
            }

            updateSituation($scope.situation)
            $scope.$watch('situation', updateSituation)
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceSituation.js